import React from 'react';
import './Spacer.scss';

export const Spacer = () => {
  return <span className="Spacer" />;
};
